__turbopack_context__.v({
  "listing_modal": "ListingModal-module-scss-module__tHzhfW__listing_modal",
  "listing_modal__channel_text": "ListingModal-module-scss-module__tHzhfW__listing_modal__channel_text",
  "listing_modal__close_btn": "ListingModal-module-scss-module__tHzhfW__listing_modal__close_btn",
  "listing_modal__duration": "ListingModal-module-scss-module__tHzhfW__listing_modal__duration",
  "listing_modal__episode_description": "ListingModal-module-scss-module__tHzhfW__listing_modal__episode_description",
  "listing_modal__episode_title": "ListingModal-module-scss-module__tHzhfW__listing_modal__episode_title",
  "listing_modal__inner": "ListingModal-module-scss-module__tHzhfW__listing_modal__inner",
  "listing_modal__logo": "ListingModal-module-scss-module__tHzhfW__listing_modal__logo",
  "listing_modal__progress": "ListingModal-module-scss-module__tHzhfW__listing_modal__progress",
  "listing_modal__progress_bar": "ListingModal-module-scss-module__tHzhfW__listing_modal__progress_bar",
  "listing_modal__show_title": "ListingModal-module-scss-module__tHzhfW__listing_modal__show_title",
  "listing_modal__time_remaining": "ListingModal-module-scss-module__tHzhfW__listing_modal__time_remaining",
  "listing_modal__watch_btn": "ListingModal-module-scss-module__tHzhfW__listing_modal__watch_btn",
});
